<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <!-- Options de validation -->
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col md="10" class="my-1 justify-content-end">
            <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..." @input="fetchUsers" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-table
                striped
                hover
                responsive
                :items="users"
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"

            >
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.lastName + ' ' + data.item.firstName }}
                  </span>
                  <small class="text-muted">{{ data.item.mail }}</small>
                </b-media>
              </template>

              <template #cell(fonction)="data">
                <span v-if="data.item.fonction" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.fonction }}
                </span>

              </template>
              <template #cell(services)="data">
                <span v-if="data.item.services" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.services.name }}
                </span>
                <small v-if="data.item.directions" class="text-muted">
                  {{ data.item.directions.name }}
                </small>
              </template>

            </b-table>
          </b-col>
        </b-row>
      </b-card-body>
      <b-col cols="12">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-1"
        />
        <p>Total: {{ totalRows }} | Par page: {{ perPage }}</p>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import { BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton } from 'bootstrap-vue';
import vSelect from 'vue-select';
import {getUsersWithoutObjective} from "@/services/UserService";
import router from '@/router';


export default {
  components: {
    BTable,
    BAvatar,
    // BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    // vSelect,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 0, // Initialisé à 0
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: ['user', 'fonction', 'services'],
      users: [],
      configs: [], // Pour stocker les configurations
    };
  },
  computed: {

    tableColumns() {
      return [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        { key: 'services', label: 'Services', sortable: true },
      ];
    },
  },
  methods: {

    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
      return `${lastInitial}${firstInitial}`
    },
    async fetchUsers() {
      const year = this.$route.params.year;
      if (!year) {
        console.error("Year undefined");
        return;
      }

      getUsersWithoutObjective(this.currentPage - 1, this.perPage, year, this.filter).then(response => {
            this.users = response.users;
            this.totalRows = response.countUser;

          }
      )
    },

  },
  watch: {


    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
    filter(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUsers();
    },
  },
  async mounted() {
    await this.fetchUsers();
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
